module.exports = __webpack_public_path__ + "static/media/Dubai_Council_Logo.2722d6f0.png";